import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index"

export const accountMappingApi = createApi({
    reducerPath: "accountMappingApi",
    baseQuery: baseQueryWithAuthLogout,
    tagTypes: ["AccountMapping"],
    endpoints: (builder) => ({
        getAccountMappingData: builder.query({
            query: ({ page = 1, limit = 25, search = "" }) => `/gl-account?page=${page}&limit=${limit}&search=${search}`,
            providesTags: ["AccountMapping"],
        }),

        saveAccountMapping: builder.mutation({
            query: (payload) => ({
                url: `/gl-account`,
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["AccountMapping"],
        }),
        updateAccountMapping: builder.mutation({
            query: ({ id, data }) => ({
                url: `/gl-account/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["AccountMapping"],
        }),

        deleteAccountMapping: builder.mutation({
            query: (id) => ({
                url: `/gl-account/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["AccountMapping"],
        }),
    }),
});

export const {
    useGetAccountMappingDataQuery,
    useSaveAccountMappingMutation,
    useUpdateAccountMappingMutation,
    useDeleteAccountMappingMutation
} = accountMappingApi;
